import { useEffect, useState } from "react";

export const useScrollbarWidth = () => {
  const [scrollbarWidth, setScrollbarWidth] = useState({ width: 0 });
  useEffect(() => {
    const getScrollbarWidth = () => {
      const scrollDiv = document.createElement("div");
      scrollDiv.setAttribute(
        "style",
        "width: 100px; height: 100px; overflow: scroll; position:absolute; top:-9999px;"
      );
      document.body.appendChild(scrollDiv);
      const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      setScrollbarWidth({ width: scrollbarWidth });
    };
    window.addEventListener("resize", getScrollbarWidth);
    getScrollbarWidth();
    return () => window.removeEventListener("resize", getScrollbarWidth);
  }, []);
  return scrollbarWidth;
};
